import { Component, EventEmitter, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TicketCustomer } from 'src/app/_provider/tickets/ticketCustumer.service';

@Component({
  selector: 'app-customer-main-mobile',
  templateUrl: './customer-main-mobile.page.html',
  styleUrls: ['./customer-main-mobile.page.scss'],
})
export class CustomerMainMobilePage implements OnInit {
  
  public mobileSegmentValue: "messages" | "details" = "messages"
  public contentScrollEvent: EventEmitter<any> = new EventEmitter<any>()

  constructor(
    public modalCtrl: ModalController,
    public ticketSrv: TicketCustomer.TicketService
  ) { }

  ngOnInit() {
  }

  public async closeModal(){
    await this.modalCtrl.dismiss()
  }

  public mobileSegmentChange(event: any){
    this.mobileSegmentValue = event.target.value
  }


}
